import React from 'react';
import { Image, View } from 'react-native';
import { Button, rem, Spacer } from 'design-system';
import { IconPhone, IconTvBold } from 'design-system/icons';
import { IconWifi } from 'design-system/icons/IconWifi';
import Text from 'design-system/Text';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import { formatAmount } from 'utils/formatting';
import QuoteCardHeader from '../QuoteCardHeader';
import QuoteCardValue from '../QuoteCardValue';
const BroadbandCard = ({ item, includeCostofNewLine, onPressSwitch, onInfoPressed }) => {
    const styles = useStyles(styleSet);
    const renderDetails = () => {
        const { data } = item;
        const { costs, broadband, contractLengthInMonths } = data;
        let speedToDownload = null;
        if (broadband)
            speedToDownload = broadband.averageDownloadSpeedKbps;
        const { totalUpfrontCost, averageMonthlyCost, newLineInstallationCharge } = costs;
        const upfrontCosts = includeCostofNewLine ? totalUpfrontCost + newLineInstallationCharge : totalUpfrontCost;
        return (<View style={styles.row}>
        <QuoteCardValue value={<>
              <Text Numbers-16>{formatAmount(averageMonthlyCost, 'GBP')}</Text> / mo
            </>} label={`£${upfrontCosts} upfront fees`}/>
        {broadband !== undefined && speedToDownload ? (<>
            <Spacer flex/>
            <QuoteCardValue value={<>
                  <Text Numbers-16>{(speedToDownload / 1000).toFixed(0)}</Text> MB
                </>} label="avg speed"/>
          </>) : null}
        <Spacer flex/>
        <QuoteCardValue value={<>
              <Text Numbers-16>{contractLengthInMonths}</Text> mo
            </>} label="contract"/>
      </View>);
    };
    const renderSwitchButton = () => (<View style={styles.row}>
      <Button hug square brandReversed flex onPress={() => onInfoPressed(item)} title="More details"/>
      <Spacer.W8 />
      <Button hug square brand flex onPress={() => onPressSwitch(item)} title="Go to website"/>
      {renderDiscountedOffer()}
    </View>);
    const renderDealType = () => {
        const { data } = item;
        const { tv, broadband, homephone } = data;
        return (<View style={styles.iconsContainer}>
        {homephone ? <IconPhone colorKey="brand" style={styles.marginLeft4}/> : null}
        {broadband ? <IconWifi colorKey="brand" style={styles.marginLeft4}/> : null}
        {tv ? <IconTvBold gradientKey="white" style={styles.marginLeft4}/> : null}
      </View>);
    };
    const renderDiscountedOffer = () => {
        const { data } = item;
        const { discountedOffers } = data;
        let imageDiscountedOffer = null;
        if (discountedOffers && discountedOffers.length) {
            if (discountedOffers[0] && discountedOffers[0].logo) {
                imageDiscountedOffer = discountedOffers[0].logo;
            }
        }
        if (!imageDiscountedOffer)
            return null;
        return (<>
        <Spacer.W8 />
        <Image source={{ uri: imageDiscountedOffer }} style={styles.discountedOffer}/>
      </>);
    };
    const { data } = item;
    const { provider } = data;
    return (<View style={styles.content}>
      <QuoteCardHeader title={provider.name} subTitle={data.name} logoUrl={provider.logo}>
        {renderDealType()}
      </QuoteCardHeader>
      <Spacer h={32}/>
      {renderDetails()}
      <Spacer h={32}/>
      {renderSwitchButton()}
    </View>);
};
const styleSet = createStyleSheets((colors) => ({
    content: {
        padding: rem(16),
        marginHorizontal: rem(16),
        borderRadius: rem(16),
        backgroundColor: colors.cards.onDark,
    },
    row: { flexDirection: 'row', alignItems: 'center' },
    flex: { flex: 1 },
    centered: { alignItems: 'center' },
    iconsContainer: { flexDirection: 'row', alignSelf: 'flex-start' },
    logoContainer: {
        width: rem(44),
        height: rem(44),
        borderRadius: rem(8),
        backgroundColor: colors.elements.white,
        alignItems: 'center',
        justifyContent: 'center',
    },
    marginLeft4: { marginLeft: rem(4) },
    discountedOffer: {
        height: rem(44),
        width: rem(44),
    },
}));
export default BroadbandCard;
